import { render, staticRenderFns } from "./AddAdmins.vue?vue&type=template&id=258841c8"
import script from "./AddAdmins.vue?vue&type=script&lang=js"
export * from "./AddAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports